import emojiData from "@emoji-mart/data";

const SHORTCODE_RE = /:([a-z0-9_+-]+):/gi;
const LEADING_SHORTCODE_RE = /^\s*:([a-z0-9_+-]+):\s*/i;

let index: Map<string, string> | null = null;

function shortcodeIndex(): Map<string, string> {
  if (index) return index;
  const map = new Map<string, string>();
  const source = emojiData as { emojis?: unknown; aliases?: unknown };
  if (source.emojis && typeof source.emojis === "object") {
    for (const [id, entry] of Object.entries(source.emojis)) {
      const native = (entry as { skins?: Array<{ native?: unknown }> }).skins?.[0]?.native;
      if (typeof native === "string" && native.length > 0) map.set(id, native);
    }
  }
  if (source.aliases && typeof source.aliases === "object") {
    for (const [alias, id] of Object.entries(source.aliases)) {
      const native = typeof id === "string" ? map.get(id) : undefined;
      if (native) map.set(alias, native);
    }
  }
  index = map;
  return map;
}

export function shortcodeToNative(code: string): string | null {
  return shortcodeIndex().get(code.toLowerCase()) ?? null;
}

export function replaceShortcodes(text: string): string {
  return text.replace(SHORTCODE_RE, (whole, code: string) => shortcodeToNative(code) ?? whole);
}

export function splitLeadingShortcode(text: string): { emoji: string; rest: string } | null {
  const match = LEADING_SHORTCODE_RE.exec(text);
  if (!match?.[1]) return null;
  const emoji = shortcodeToNative(match[1]);
  if (!emoji) return null;
  return { emoji, rest: text.slice(match[0].length) };
}
